import { API } from 'lib/api';
import { COMMON_ENDPOINT } from 'constant/endpoints/common';
import { ITenant } from 'types/globals';
import { IStateResponse } from 'types/common';
import type { IStonlyData } from 'types/StonlyData';
import {
  IEquipmentParams,
  IEquipmentWithGroup,
  IEquipmentWithoutGroup,
} from 'types/Equipment/equipment';
import { ONBOARDING_ENDPOINTS } from 'constant/endpoints/onboarding';

export const fetchState = async (
  countryId?: string,
): Promise<IStateResponse> => {
  const { data } = await API.get(COMMON_ENDPOINT.STATE, {
    ...(countryId ? { params: { country: countryId } } : {}),
  });
  return data;
};

export const fetchCountry = async (): Promise<IStateResponse> => {
  const { data } = await API.get(COMMON_ENDPOINT.COUNTRY);
  return data;
};

export const fetchStonly = async (): Promise<IStonlyData> => {
  const { data } = await API.get<IStonlyData>(COMMON_ENDPOINT.STONLY);
  return data;
};

export const fetchTenantInformation = async (
  searchText?: string,
): Promise<ITenant[]> => {
  const { data } = await API.get<ITenant[]>(COMMON_ENDPOINT.GET_TENANTS, {
    ...(searchText ? { params: { q: searchText } } : {}),
  });
  return data;
};

export const fetchEquipmentsDropdown = async <T extends boolean>(
  params: IEquipmentParams & { group_response: T },
  options: { signal: AbortSignal },
): Promise<T extends true ? IEquipmentWithGroup : IEquipmentWithoutGroup> => {
  const { data } = await API.get<IEquipmentWithGroup | IEquipmentWithoutGroup>(
    COMMON_ENDPOINT.GET_EQUIPMENTS_DROPDOWN,
    { signal: options.signal, params },
  );
  return data as T extends true ? IEquipmentWithGroup : IEquipmentWithoutGroup;
};

export const resetTenantOnboardingSkip = async () => {
  const { data } = await API.patch(
    ONBOARDING_ENDPOINTS.TENANT_ONBOARDING_SKIPPED,
    {
      is_onboarding_skipped: false,
    },
  );
  return data;
};
